import Cookies from 'js-cookie';
import { v4 as uuidv4, validate as validateUuid } from 'uuid';
import '../styles/style.scss';

(($) => {
    const LIKES_KEY = 'mm-personalization-likes';
    const UUID_KEY = 'mm-personalization-uuid';
    const PERSONA_KEY = 'mmpersona-js';
    const LOCATION_KEY = 'mm-location';
    const postId = typeof loc_object !== 'undefined' && loc_object.post_id ? parseInt(loc_object.post_id) : false;
    const postType = typeof loc_object !== 'undefined' && loc_object.post_type ? loc_object.post_type : '';
	let userUuid;
    
    // Debug flag
    const debug = loc_object.debug || false;

    // Fetch permitted post types for likes
    const fetchPermittedPostTypes = () => {
        return $.ajax({
            url: loc_object.ajax_url,
            method: 'POST',
            data: {
                action: 'getPermittedPostTypes',
                _wpnonce: loc_object.ajax_nonce
            }
        });
    };

    // Fetch persona scores for a given post
    const fetchPersonaScores = () => {
        return $.ajax({
            url: loc_object.ajax_url,
            method: 'POST',
            data: {
                action: 'get_results_for_ontology_test',
                _wpnonce: loc_object.ajax_nonce,
                post_id: postId
            }
        });
    };

    /**
     * Parse out the current value of an encoded data cookie
     * @param {String} key The key to check for the cookie
     * @return {*} The cookie's decoded value
     */
    const parseDataCookie = function (key) {
        const rawCookieVal = Cookies.get(key);

        if (rawCookieVal) {
            try {
                return JSON.parse(atob(decodeURIComponent(rawCookieVal)));
            } catch (error) {
                console.error('Error parsing cookie:', error);
                return false;
            }
        } else {
            return false;
        }
    };

	/**
	 * Set the value of an encoded data cookie
	 * @param {String} key The cookie's key
	 * @param {*} rawCookieVal The cookie's value
	 * @param {Number} days The cookie's expiration value in days
	 * @param {String} sameSite The cookie's samesite attribute
	 */
	const setDataCookie = function (key, rawCookieVal, days, sameSite) {
		if (!sameSite) sameSite = 'Strict';

		// Ensure the value is a string
		let rawStringVal = typeof rawCookieVal === 'string' ? rawCookieVal : JSON.stringify(rawCookieVal);

		// Trim any extraneous whitespace or non-printable characters
		rawStringVal = rawStringVal.trim();

		let parsedData;
		try {
			parsedData = JSON.parse(rawStringVal);
			// No need to check for array, just ensure it's a valid JSON
		} catch (e) {
			console.error('Invalid JSON:', e);
			return;
		}

		const cleanedRawCookieVal = JSON.stringify(parsedData);
		const encodedCookieVal = btoa(cleanedRawCookieVal);
		Cookies.set(key, encodedCookieVal, { expires: days, sameSite: sameSite, path: '/' });
	};

	/**
	 * Update the location personalization cookie using the JS Geolocation API
	 */
	function setLocationCookie() {
		// Set geolocation cookie
		const currentLocCookie = Cookies.get(LOCATION_KEY);
		if (currentLocCookie == 'undefined' && navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(location) => {
					// // Mark this as a successful location share in GA
					// dataLayer.push('event', 'location_share', {
					// 	location_share: true
					// });

					// Prep AJAX data
					const data = {
						action: 'updateLocationSharingAnalytics',
						_wpnonce: loc_object.ajax_nonce,
						location: {
							latitude: location.coords.latitude,
							longitude: location.coords.longitude,
						},
					};

					// Make AJAX request
					$.post(loc_object.ajax_url, data, (response) => {
						if (response.success) {

							const expr = 7; // 1 week in days
							Cookies.set(LOCATION_KEY, false, { expires: expr, sameSite: 'Strict', path: '/' });
						} else {
							console.error(response.data);
						}
					});
				},
				(err) => {
					console.error(err);
					logBlock();
				}
			);
		}
	}

	/**
	 * Log the blocked location share
	 * @returns {void}
	 * @private
	 * @since 1.0.0
	 **/
	function logBlock() {
		// Log blocked location share
		const data = {
			action: 'logLocationBlock',
			_wpnonce: loc_object.ajax_nonce
		};

		// Make AJAX request
		$.post(loc_object.ajax_url, data, (response) => {
			if (response.success) {
				// Set the LOCATION_KEY cookie to indicate location sharing is blocked
				const newCookieVal = {
					type: 'blocked',
					data: {},
					match: 'blocked',
				};

				const expr = 7; // 1 week in days
				Cookies.set(LOCATION_KEY, false, { expires: expr, sameSite: 'Strict', path: '/' });
			} else {
				console.error(response.data);
			}
		});
	}

    /**
     * Fetch user-likes UUID, if one exists and is valid
     * @returns {String|Boolean} The user's UUID, or false if none exists
     */
    function getUuid() {
        const userId = Cookies.get(UUID_KEY);
        return validateUuid(userId) ? userId : 'anonymous';
    }

    /**
     * Fetch the users UUID and create a new UUID if one doesn't currently exist
     * @returns {String} The user's UUID
     */
    function setUuid() {
        let userId = getUuid();
        if (!userId) {
            userId = uuidv4();
            Cookies.set(UUID_KEY, userId, { expires: 365, path: '/' });
        }
        return userId;
    }

    /**
     * Update the user's current liked posts
     * @param {Number} pID The current post's WP ID
     * @param {Boolean} toAdd Should this post be added (or deleted?)
     * @returns
     */
    function updateLikes(pID, toAdd = true) {
        const currentLikes = JSON.parse(Cookies.get(LIKES_KEY) || '[]');
        const userKey = userUuid; // Use the stored UUID

        // Prep AJAX data
        const ajaxData = {
            _wpnonce: loc_object.ajax_nonce,
            pID,
            userKey,
        };

        if (toAdd) {
            currentLikes.push(pID);

            ajaxData.action = 'createLike';

            // Make AJAX request
            $.post(loc_object.ajax_url, ajaxData, (response) => {
                if (!response.success) console.error(response.data);
            });
        } else {
            currentLikes.splice(currentLikes.indexOf(pID), 1);

            ajaxData.action = 'deleteLike';

            // Make AJAX request
            $.post(loc_object.ajax_url, ajaxData, (response) => {
                if (!response.success) console.error(response.data);
            });
        }

        Cookies.set(LIKES_KEY, JSON.stringify(currentLikes), { expires: 365, path: '/' });
    }

    /**
     * Update liked posts when button is clicked
     * @returns {null}
     */
    function onLikeButtonClick() {
        const likeBtn = $(this).find('#mm-personalization-like-button');
        likeBtn.toggleClass('liked');

        if (likeBtn.hasClass('liked')) {
            likeBtn.find('.like-button-text').text('Liked!');
            if (postId) updateLikes(postId);

            // Little floaty heart animation
            const svgClone = $(likeBtn).find('svg').clone();
            svgClone.css('z-index', 0);
            $(likeBtn).prepend(svgClone);
            svgClone.addClass('animate');
            setTimeout(() => {
                svgClone.removeClass('animate');
                svgClone.remove();
            }, 30001);

            // dataLayer push
            let pageTitle = $(likeBtn).data('title');
            let userId = userUuid; // Use the stored UUID

            if (window?.dataLayer?.push) {
                window.dataLayer.push({
                    event: 'likeClick',
                    event_action: 'Like Click',
                    page_title: pageTitle,
                    user_id: userId
                });
            }
            if(debug){
                console.log('likeClick', {
                    event: 'likeClick',
                    event_action: 'Like Click',
                    page_title: pageTitle,
                    user_id: userId
                });
            }
        } else {
            likeBtn.find('.like-button-text').text('Like this');
            if (postId) updateLikes(postId, false);
        }
    }

    /**
     * Initialize and set the mmpersona cookie
     */
    function updatePersonaScores(newScores) {
        let personaCookie = parseDataCookie(PERSONA_KEY);

        if (personaCookie) {
            newScores.forEach(newScore => {
                const existingScore = personaCookie.find(score => score.name === newScore.name);
                if (existingScore) {
                    existingScore.score = ((parseFloat(existingScore.score) + parseFloat(newScore.score)) / 2).toFixed(6);
                } else {
                    personaCookie.push(newScore);
                }
            });

            setDataCookie(PERSONA_KEY, personaCookie, 365);
        } else {
            // Create a new persona cookie with the newScores
            setDataCookie(PERSONA_KEY, newScores, 365);
        }
    }

    $(document).ready(() => {
        userUuid = setUuid(); // Store the UUID once

        setLocationCookie();

        if (postId) {
            fetchPersonaScores().done(response => {
                if (response.success) {
                    const personaScores = response.data[0].message.data;

                    updatePersonaScores(personaScores);
                }
            });
        }

        fetchPermittedPostTypes().done(response => {
            if (response.success) {
                const permittedPostTypes = Object.keys(response.data); // Get the keys of the response data

                if (window.location.pathname !== '/' && permittedPostTypes.includes(postType)) {
                    const currentLikes = JSON.parse(Cookies.get(LIKES_KEY) || '[]');
                    const isLiked = currentLikes.includes(postId);
                    const pageTitle = $('title').text() ? $('title').text() : 'unknown';

                    // HTML for likes button
                    const likeButton = $(`
                        <div class='mm-personalization-like-box'>
                            <button id='mm-personalization-like-button' data-title='${pageTitle}' class='${isLiked ? 'liked' : ''} like-button'>
                                <span class='like-button-text'>${isLiked ? 'Liked!' : 'Like this'}</span>
                                <svg width="50" height="50" viewBox="0 0 128 128">
                                    <path d="M90.35,16.05c-11.66,0-21.81,6.97-26.35,17.06c-4.54-10.08-14.69-17.06-26.35-17.06 c-15.92,0-28.87,12.96-28.87,28.88c0,35.9,51.79,65.46,54,66.7c0.38,0.21,0.79,0.32,1.21,0.32c0.42,0,0.84-0.11,1.21-0.32 c2.2-1.24,54.01-30.8,54.01-66.7C119.22,29.01,106.27,16.05,90.35,16.05z"/>
                                </svg>
                            </button>
                        </div>`).click(onLikeButtonClick);
                    $('body').append(likeButton);
                }
            }
        });

        const elementsToTrack = [
            '.madden-personalized-block-wrap a',
            '.nlp-discover-more-link',
            '.nlp-read-more-link',
            '.syml-story a'
        ];

        const observerOptions = {
            root: null, // Use the document's viewport as the root
            rootMargin: '0px',
            threshold: 0.1 // 10% of the element must be visible to trigger the callback
        };

        const timeInView = new Map(); // To track time in view for each element

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const element = entry.target;
                if (entry.isIntersecting) {
                    // Element has entered the viewport
                    if (!timeInView.has(element)) {
                        timeInView.set(element, { startTime: Date.now(), totalTime: 0 });
                    } else {
                        const data = timeInView.get(element);
                        data.startTime = Date.now();
                    }
                } else {
                    // Element has exited the viewport
                    if (timeInView.has(element)) {
                        const data = timeInView.get(element);
                        const timeSpent = Date.now() - data.startTime;
                        data.totalTime += timeSpent;

                        // Send data to analytics
                        sendEngagementData(element, data.totalTime);
                        timeInView.delete(element);
                    }
                }
            });
        }, observerOptions);

        elementsToTrack.forEach(selector => {
            $(document).on('click', selector, function(e) {
                handleElementClick(e, selector);
            });
            $(selector).each(function() {
                observer.observe(this);
            });
        });

        function handleElementClick(e, selector) {
            let pageTitle, userId = userUuid; // Use the stored UUID

            if (selector === '.madden-personalized-block-wrap a') {
                let closestPersonaAncestory = $(e.target).closest('.madden-personalized-block-wrap');
                let personaName = $(closestPersonaAncestory).data('persona-name');
                pageTitle = personaName;
                if (window?.dataLayer?.push) {
                    window.dataLayer.push({
                        event: 'personalizedClick',
                        event_action: 'Personalized Click',
                        persona_name: personaName,
                        user_id: userId
                    });
                }
                if(debug){
                    console.log('personalizedClick', {
                        event: 'personalizedClick',
                        event_action: 'Personalized Click',
                        persona_name: personaName,
                        user_id: userId
                    });
                }
            } else if (selector === '.nlp-discover-more-link') {
                pageTitle = $(e.target).find('.postTitle').text();
                if (window?.dataLayer?.push) {
                    window.dataLayer.push({
                        event: 'discoverMoreClick',
                        event_action: 'Discover More Click',
                        page_title: pageTitle,
                        user_id: userId
                    });
                }
                if(debug){
                    console.log('discoverMoreClick', {
                        event: 'discoverMoreClick',
                        event_action: 'Discover More Click',
                        page_title: pageTitle,
                        user_id: userId
                    });
                }
            } else if (selector === '.nlp-read-more-link') {
                pageTitle = $(e.target).text();
                if (window?.dataLayer?.push) {
                    window.dataLayer.push({
                        event: 'readMoreClick',
                        event_action: 'Read More Click',
                        page_title: pageTitle,
                        user_id: userId
                    });
                }
                if(debug){
                    console.log('readMoreClick', {
                        event: 'readMoreClick',
                        event_action: 'Read More Click',
                        page_title: pageTitle,
                        user_id: userId
                    });
                }
            } else if (selector === '.syml-story a') {
                pageTitle = $(e.target).find('.story-title').text();
                if (window?.dataLayer?.push) {
                    window.dataLayer.push({
                        event: 'storiesYouMayLikeClick',
                        event_action: 'Stories You May Like Click',
                        page_title: pageTitle,
                        user_id: userId
                    });
                }
                if(debug){
                    console.log('storiesYouMayLikeClick', {
                        event: 'storiesYouMayLikeClick',
                        event_action: 'Stories You May Like Click',
                        page_title: pageTitle,
                        user_id: userId
                    });
                }
            }
        }

        function sendEngagementData(element, timeInMilliseconds) {
			let closestPersonaAncestory = $(element).closest('.madden-personalized-block-wrap');
			let personaName = $(closestPersonaAncestory).data('persona-name');
            const eventData = {
                event: 'personalizationEngagement',
                event_action: 'Personalization Engagement',
                element: element.outerHTML,
                time_in_view: timeInMilliseconds,
				persona_name: personaName,
                user_id: userUuid // Use the stored UUID
            };
            if (window?.dataLayer?.push) {
                window.dataLayer.push(eventData);
            }
            if(debug){
                console.log('elementInView', eventData);
            }
        }
    });

})(jQuery);
